import { useEffect, useState } from "react";
import { Button, Drawer } from "antd";
import { NavLink, Link, Outlet, useLocation } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { Brand } from "./Editorial";

const links = [
  ["/", "Podsumowanie"],
  ["/library", "Biblioteka"],
  ["/stats", "Statystyki"],
  ["/waiting-room", "Poczekalnia"],
];

export function PublicLayout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);
  const navigation = (
    <nav aria-label="Nawigacja główna">
      {links.map(([to, label]) => (
        <NavLink key={to} to={to} end={to === "/"}>
          {label}
        </NavLink>
      ))}
    </nav>
  );
  return (
    <div className="editorial-site">
      <a className="skip-link" href="#main-content">
        Przejdź do treści
      </a>
      <header className="site-header">
        <div className="header-inner">
          <Link
            to="/"
            className="brand-link"
            aria-label="Mordeczka.eu — strona główna"
          >
            <Brand />
          </Link>
          <div className="desktop-navigation">{navigation}</div>
          <Button
            className="mobile-menu-button"
            type="text"
            icon={<MenuOutlined />}
            onClick={() => setOpen(true)}
            aria-expanded={open}
            aria-label="Otwórz menu"
          />
        </div>
      </header>
      <Drawer
        title={<Brand />}
        placement="right"
        open={open}
        onClose={() => setOpen(false)}
        width={300}
      >
        <div className="mobile-navigation">{navigation}</div>
      </Drawer>
      <main id="main-content" className="site-content" tabIndex={-1}>
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="footer-inner">
          <Link to="/" className="brand-link">
            <Brand />
          </Link>
          <p>
            Osobisty dziennik książek, filmów i seriali.
            <br />
            <span>© {new Date().getFullYear()} mordeczka.eu</span>
          </p>
          <Link to="/stats">Historie w liczbach →</Link>
        </div>
      </footer>
    </div>
  );
}
